export default {"src":"/_next/static/image/src/images/ollie-tail-wag.1054239464e29c386f206e087d3bac31.svg","height":185,"width":141};